import React, { useEffect, useState } from "react"
import BigArticleCard from "../page-components/blog/BigArticleCard"
import { listPublishedArticle } from "../HelpingFunction/Article/ArticleDBHelper"
import { Article } from "../Model/Article"
import ArticleCard from "../page-components/blog/ArticleCard"
import { getUserLang } from "../Utils/utiltyHelper"
import { Trans, useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"

const blog = () => {
  const { t } = useTranslation()

  const [articles, setArticles] = useState<Article[]>([])
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  useEffect(() => {
    getAllArticles()
  }, [])
  const getAllArticles = async () => {
    const lang = getUserLang()

    await listPublishedArticle(lang === "en" ? "EN" : "CHI").then((res) => {
      if (res.success) {
        setArticles(res.data)
        setIsLoaded(true)
      } else {
        console.log("Failed to get Articles")
      }
    })
  }

  return (
    <>
      <Helmet>
        <title>{t("Blog.title")}</title>
        <link
          rel="alternate"
          href={
            "https://look4kol.com/" +
            (localStorage.getItem("i18n-lang") === "en" ? "hk" : "en") +
            "/blog"
          }
          hrefLang={
            localStorage.getItem("i18n-lang") === "en" ? "zh-Hant" : "en"
          }
        />
        <meta property="fb:app_id" content="1293953327456577" />
        <meta property="og:type" content="website" />
        <meta property="site_name" content="look4kol" />
        <meta property="title" content={t("Blog.title") as string} />
        <meta name="description" content={t("Blog.description") as string} />
        <meta name="keywords" content={t("Blog.keywords") as string} />
        <meta property="og:title" content={t("Blog.title") as string} />
        <meta
          property="og:description"
          content={t("Blog.description") as string}
        />
        <meta property="og:image" content="https://i.imgur.com/3rWRNx5h.png" />
        <meta property="og:url" content="https://look4kol.com" />
      </Helmet>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-18 md:py-12 py-4 ">
        <section className="mt-20">
          <div className="text-primary text-center uppercase font-bold ">
            <Trans>Blog.title-2</Trans>
          </div>
          <h1 className="md:text-6xl text-3xl text-center normal-case font-bold mt-4">
            <p className="my-2">
              <Trans>Blog.title-3</Trans>
            </p>
          </h1>
        </section>
        <section className="my-20 w-full">
          {isLoaded && articles.length > 0 && (
            <BigArticleCard article={articles[0]} />
          )}
        </section>
        <section className="my-20">
          <div className="md:grid md:grid-cols-3 gap-4">
            {isLoaded &&
              articles.map((article, index) => {
                if (index !== 0) {
                  return (
                    <ArticleCard
                      key={article.id}
                      article={article}
                      isCarousel={false}
                    />
                  )
                }
              })}
          </div>
        </section>
      </div>
    </>
  )
}

export default blog
